import { Component } from 'react';
import { fromJS } from 'immutable';

import { FormattedMessage } from 'react-intl';

import { DropdownSearchMenuContent } from './Search.styles';

import Search from './Search.component';
import { DropdownMenuItem } from 'components/DropdownMenu/DropdownMenu.styles';

class SearchWithDropdown extends Component {
  static defaultProps = {
    children: null,
    maxResults: 3,
    results: fromJS([]),
    searchQuery: '',
    onChangeSearchQuery: () => null,
  };

  state = {
    focusedIndex: 0,
  };

  // @ts-expect-error TS(2339): Property 'results' does not exist on type 'Readonl... Remove this comment to see the full error message
  getActiveResult = () => this.props.results.get(this.state.focusedIndex);

  // @ts-expect-error TS(2339): Property 'results' does not exist on type 'Readonl... Remove this comment to see the full error message
  getDropDownItemLength = () => Math.min(this.props.results.size, this.props.maxResults);

  incrementSelectedIndex = () => {
    const length = this.getDropDownItemLength();
    const incrementedIndex = this.state.focusedIndex + 1;
    const focusedIndex = incrementedIndex < length ? incrementedIndex : 0;

    this.setState({ focusedIndex });
  };

  decrementSelectedIndex = () => {
    const length = this.getDropDownItemLength();
    const incrementedIndex = this.state.focusedIndex - 1;
    const focusedIndex = incrementedIndex === -1 ? length - 1 : incrementedIndex;

    this.setState({ focusedIndex });
  };

  keyDownHandler = (event) => {
    // @ts-expect-error TS(2339): Property 'results' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (!this.props.results.size) {
      return;
    }

    switch (event.keyCode) {
      case 13: // 'Enter'
        // @ts-expect-error TS(2339): Property 'onItemSelect' does not exist on type 'Re... Remove this comment to see the full error message
        this.props.onItemSelect(this.getActiveResult());
        break;
      case 40: // 'Down Arrow'
        this.incrementSelectedIndex();
        break;
      case 38: // 'Up Arrow'
        this.decrementSelectedIndex();
        break;
      default:
    }
  };

  // @ts-expect-error TS(2339): Property 'onItemSelect' does not exist on type 'Re... Remove this comment to see the full error message
  getItemClickHandler = (item) => () => this.props.onItemSelect(item);

  // @ts-expect-error TS(2339): Property 'searchQuery' does not exist on type 'Rea... Remove this comment to see the full error message
  shouldShowProps = () => Boolean(this.props.searchQuery && this.props.results.size);

  renderResults = () => {
    // @ts-expect-error TS(2339): Property 'results' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (!this.props.results.size) {
      return null;
    }

    // @ts-expect-error TS(2339): Property 'results' does not exist on type 'Readonl... Remove this comment to see the full error message
    const results = this.props.results.slice(0, this.props.maxResults);

    const items = results.map((result, index) => (
      <DropdownMenuItem
        key={result.get('id')}
        active={index === this.state.focusedIndex}
        onClick={this.getItemClickHandler(result)}
      >
        {/* @ts-expect-error TS(2339): Property 'resultTemplateId' does not exist on type... Remove this comment to see the full error message */}
        <FormattedMessage id={this.props.resultTemplateId} values={this.props.resultExtractor(result)} />
      </DropdownMenuItem>
    ));

    return items;
  };

  render = () => (
    // @ts-expect-error TS(2769): No overload matches this call.
    <Search {...this.props} handleKeyDown={this.keyDownHandler}>
      {this.shouldShowProps() ? (
        // @ts-expect-error TS(2769): No overload matches this call.
        <DropdownSearchMenuContent width="100%">{this.renderResults()}</DropdownSearchMenuContent>
      ) : null}
    </Search>
  );
}

export default SearchWithDropdown;
